<script setup lang="ts">
interface CheckboxProps {
    checked: boolean;
    mode?: "list" | "check";
    size?: "md" | "sm";
    disabled?: boolean;
    allSelected?: boolean;
}

withDefaults(defineProps<CheckboxProps>(), {
    mode: "check",
    disabled: false,
    checked: false,
    allSelected: false,
    size: "md",
});

const emit = defineEmits(["input"]);

const input = (event: MouseEvent) => {
    emit("input", event);
};
</script>

<template>
    <div :class="['ds-checkbox', size, { disabled, checked }]" @click.stop="input">
        <div class="inner-checkbox" v-if="checked">
            <i v-if="mode === 'list' && !allSelected" class="ti ti-minus"></i>
            <i v-if="mode === 'check' || (mode === 'list' && allSelected)" class="ti ti-check bold"></i>
        </div>
    </div>
</template>

<style scoped lang="scss">
.ds-checkbox {
    cursor: pointer;
    display: inline-flex;
    position: relative;

    @include square(20px);
    border: 2px solid $stroke-sub-300;
    transition: 0.2s;
    border-radius: 4px;
    background-color: $bg-white-0;

    &:hover {
        background-color: $bg-weak-100;
    }

    &.checked {
        background-color: $blue-base;
        border-color: $blue-base;

        &:hover {
            background-color: $blue-dark;
            border-color: $blue-dark;
        }
    }

    .inner-checkbox {
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;

        .ti {
            color: $icon-white-0;
            font-size: 14px;
        }
    }

    &.sm {
        @include square(16px);

        .inner-checkbox {
            .ti {
                color: $icon-white-0;
                font-size: 9px;
            }
        }
    }

    &.disabled {
        cursor: default;
        pointer-events: none;
        border-color: $bg-soft-200;

        &:hover {
            background-color: $bg-white-0;
        }

        &.checked {
            background-color: $bg-soft-200;

            &:hover {
                border-color: $bg-soft-200;
            }
        }
    }
}
</style>
